"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@emotion/core");
const Constants_1 = require("./Constants");
const drawerContainerCss = (breakpoint) => core_1.css({
    display: 'flex',
    alignItems: 'stretch',
    justifyContent: 'stretch',
    height: '100%',
    overflow: 'auto',
    width: '100%',
    [`@media ${breakpoint}`]: {
        position: 'relative',
    },
});
const DrawerContainer = ({ breakpoint = Constants_1.BREAKPOINT, children, }) => (core_1.jsx("div", { css: drawerContainerCss(breakpoint) }, children));
DrawerContainer.defaultProps = {
    breakpoint: Constants_1.BREAKPOINT,
};
exports.default = DrawerContainer;
